import {gql} from "@apollo/client";
import {OrderType} from "../../../../../graphql/types/OrderType";
import {OrderFiltersType} from "../../../../../graphql/types/OrderFiltersType";
import {ORDER_FIELDS} from "../../../../central/parcels/graphql/queries/getOrderListingForCentral";

export const GET_ORDER_LISTING_FOR_DELIVERY = gql`
    query DeliveryQuery($warehouseId: Long!,
                        $filters: OrderFiltersTypeInput,
                        $pageRequest: PageRequestTypeInput) {
        getOrderListingForDelivery(warehouseId: $warehouseId,
                                   filters: $filters,
                                   pageRequest: $pageRequest) {
            content{
                ${ORDER_FIELDS}
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface DeliveryOrderListResponse {
    getOrderListingForDelivery: OrderListingResponseType;
}

export interface OrderListingResponseType {
    content: OrderType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

interface GetOrderListingForDeliveryInput {
    warehouseId: number;
    dspId: number;
    filters?: OrderFiltersType;
    pageRequest?: PageRequestType;
}

interface PageRequestType {
    page: number;
    size: number;
    sortBy: string;
    sortDirection: string;
}
